module.exports = __webpack_public_path__ + "img/img6.dd6128fc.jpg";